module.exports = __webpack_public_path__ + "media/images/products/fmt100/fmt100-1-1000x1000-9d3af3696bedae58c9c540e9e91e66f1.png";